import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoodle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "4 10 39 27",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffab40",
			d: "M33.5,16c-2.5,0-4.8,1-6.5,2.6C25.3,17,23,16,20.5,16c-5.2,0-9.5,4.3-9.5,9.5V37h6V24.5 c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5V37h6V24.5c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5V37h6V25.5C43,20.3,38.7,16,33.5,16z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M5.5 16.2H6.5V32H5.5z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "#424242",
			d: "M22,13c1.1,0.4,2.6,2,3,3c-1.8,1.7-2.6,2.9-3,6c-0.1,1.1-0.9,1.7-2,1c-3.1-1.9-6-2-8-2 c-1-1-0.5-3.7,0-5l6,1L22,13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#616161",
			d: "M18,17H4l11-7h14L18,17z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#424242",
			d: "M7.5,30c0-2.2-0.7-4-1.5-4s-1.5,1.8-1.5,4s0.7,4,1.5,4S7.5,32.2,7.5,30z"
		})
	]
});
export default SvgMoodle;
